module.exports = __webpack_public_path__ + "img/prize2.330218e4.png";